import axios from 'axios'

export function getAdminPassword() {
  return sessionStorage.getItem('adminPassword') || ''
}

// API base URL - empty because endpoints already include full path
const API_BASE = ''

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add auth header
apiClient.interceptors.request.use(
  (config) => {
    config.headers['x-admin-password'] = getAdminPassword()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * Generic API request helper
 * @param {string} method - HTTP method (get, post, put, delete)
 * @param {string} url - API endpoint (relative to baseURL)
 * @param {Object} options - Additional options (params, data, etc.)
 * @returns {Promise} - Axios response
 */
export async function apiRequest(method, url, options = {}) {
  const { params, data, ...rest } = options

  try {
    const response = await apiClient.request({
      method: method.toLowerCase(),
      url,
      params,
      data,
      ...rest
    })
    return response
  } catch (error) {
    console.error(`API ${method.toUpperCase()} ${url} error:`, error)
    throw error
  }
}

/**
 * GET request helper
 * @param {string} url - API endpoint
 * @param {Object} params - Query parameters
 * @param {Object} options - Additional axios options
 * @returns {Promise} - Axios response
 */
export function apiGet(url, params = {}, options = {}) {
  return apiRequest('get', url, { params, ...options })
}

/**
 * POST request helper
 * @param {string} url - API endpoint
 * @param {Object} data - Request body
 * @param {Object} options - Additional axios options
 * @returns {Promise} - Axios response
 */
export function apiPost(url, data = {}, options = {}) {
  return apiRequest('post', url, { data, ...options })
}

/**
 * PUT request helper
 * @param {string} url - API endpoint
 * @param {Object} data - Request body
 * @param {Object} options - Additional axios options
 * @returns {Promise} - Axios response
 */
export function apiPut(url, data = {}, options = {}) {
  return apiRequest('put', url, { data, ...options })
}

/**
 * DELETE request helper
 * @param {string} url - API endpoint
 * @param {Object} options - Additional axios options
 * @returns {Promise} - Axios response
 */
export function apiDelete(url, options = {}) {
  return apiRequest('delete', url, options)
}

export default {
  getAdminPassword,
  apiClient,
  apiRequest,
  apiGet,
  apiPost,
  apiPut,
  apiDelete
}
